import React from 'react';
import { CustomerItem, tierColors, healthColors } from '../customersTypes';
import { RowActionsMenu } from '../../../../components/RowActionsMenu';
import styles from './CustomerTable.module.css';

interface CustomerTableProps {
  items: CustomerItem[];
  onEdit?: (id: number) => void;
}

export const CustomerTable: React.FC<CustomerTableProps> = ({ items, onEdit }) => {
  const showActions = !!onEdit;
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>CUSTOMER</th>
            <th>TIER</th>
            <th>SCORE</th>
            <th className={styles.right}>REVENUE</th>
            <th className={styles.right}>MARGIN %</th>
            <th className={styles.right}>ORDERS/WEEK</th>
            <th className={styles.right}>AOV</th>
            <th>HEALTH</th>
            <th className={styles.right}>CLAIMS</th>
            {showActions && <th></th>}
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => {
            const tc = tierColors[item.tier];
            const hc = healthColors[item.health];
            const isMarginGreen = item.marginPercent >= 15;

            return (
              <tr key={item.id ?? idx}>
                <td>
                  <div className={styles.customerName}>{item.name}</div>
                  <div className={styles.customerLocation}>{item.location}</div>
                </td>
                <td>
                  <span className={styles.tierBadge} style={{ background: tc.bg, color: tc.color }}>
                    {item.tier}
                  </span>
                </td>
                <td>
                  <span className={styles.scoreValue}>{item.score}</span>
                  {item.scoreTrend === 'up' ? (
                    <svg className={styles.trendUp} viewBox="0 0 24 24" fill="currentColor"><path d="M7 14l5-5 5 5z"/></svg>
                  ) : (
                    <svg className={styles.trendDown} viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg>
                  )}
                </td>
                <td className={styles.right}>${item.revenue.toLocaleString()}</td>
                <td className={`${styles.right} ${isMarginGreen ? styles.marginGreen : ''}`}>
                  {item.marginPercent.toFixed(1)}%
                </td>
                <td className={styles.right}>{item.ordersPerWeek.toFixed(1)}</td>
                <td className={styles.right}>${item.aov.toLocaleString()}</td>
                <td>
                  <span className={styles.healthBadge} style={{ background: hc.bg, color: hc.color }}>
                    {item.health}
                  </span>
                </td>
                <td className={styles.right}>
                  {item.claims > 0 ? (
                    <span className={styles.claimsAlert}>
                      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                      {item.claims}
                    </span>
                  ) : (
                    <span className={styles.claimsNone}>0</span>
                  )}
                </td>
                {showActions && (
                  <td>
                    <RowActionsMenu onEdit={() => onEdit!(item.id)} />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
